import React, { useEffect, useState } from 'react'
import { OrdersAPI5ClientCtx, RestaurantsAPI5ClientCtxx, PaymentsAPI2ClientCtx } from 'context'
import ApolloClient from 'apollo-boost'
import Welcome from 'components/welcome'

const client = require('api/auth')

export default function GraphQLApplication(props) {
  const [ordersClient, setOrdersClient] = useState(null)
  const [restaurantsClient, setRestaurantsClient] = useState(null)
  const [paymentsClient, setPaymentsClient] = useState(null)
  const access_token = client && client.getAuthResponse() ? client.getAuthResponse().access_token : null

  useEffect(() => {
    const token = client && client.getAuthResponse() ? client.getAuthResponse().access_token : null
      if (token) {
        setOrdersClient(new ApolloClient({ uri: ORDERS_SVC_API5 + "/graphql", headers: { 'Authorization': `Bearer ${token}` } }))
        setRestaurantsClient(new ApolloClient({ uri: RESTAURANTS_SVC_API5 + "/graphql", headers: { 'Authorization': `Bearer ${token}` } }))
        setPaymentsClient(new ApolloClient({ uri: PAYMENTS_SVC_API2 + "/graphql", headers: { 'Authorization': `Bearer ${token}` } }))
      }
    }
  , [access_token])

  if (ordersClient && restaurantsClient && paymentsClient)
    return (
      <RestaurantsAPI5ClientCtxx.Provider value={restaurantsClient}>
        <OrdersAPI5ClientCtx.Provider value={ordersClient}>
          <PaymentsAPI2ClientCtx.Provider value={paymentsClient}>
            {props.children}
          </PaymentsAPI2ClientCtx.Provider>
        </OrdersAPI5ClientCtx.Provider>
      </RestaurantsAPI5ClientCtxx.Provider>
    )
  else
    return <Welcome></Welcome>

}
